/** Only known internal pages may receive authentication redirects. */
export function safeReturnTo(value: string | null, fallback = '/account') {
  if (!value || !value.startsWith('/') || value.startsWith('//') || /[\\\x00-\x20]/.test(value)) return fallback;
  try {
    const url = new URL(value, 'https://internal.invalid');
    if (url.origin !== 'https://internal.invalid' || !['/studio', '/account', '/videos', '/checkout', '/admin'].includes(url.pathname)) return fallback;
    if (url.pathname === '/checkout') {
      const transaction = url.searchParams.get('_ptxn');
      return transaction && /^txn_[a-z0-9]+$/.test(transaction) ? `/checkout?_ptxn=${transaction}` : '/account';
    }
    if (url.pathname === '/account' && ['month', 'year'].includes(url.searchParams.get('interval') ?? '')) return `/account?interval=${url.searchParams.get('interval')}`;
    return url.pathname;
  } catch { return fallback; }
}
